(function($) {

  $(document).ready(function() {
    collection.init();
  });

  if ($(".engoj-collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }


  var collection = {
    init: function() {

      /* Collection Filter */
      this.initCollectionFilter();

	  /* Collection Sorting */
      this.initCollectionSorting();

    },


    /* --------------------------------------------------------- */
    /* Review */
    initReview: function() {

        // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();

    },

    /* Hide Dropdown */
    initToggle: function(){

    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function() {

    },

    // fillterTagEvents: function() {

    //   $( "body" ).delegate( '.filter-tag a:not(".clear"), .filter-tag label', 'click',function(e) {
    //     // console.log('#111')
        
    //     var $filter = $(this).closest('.filter-tag');
    //     // Allow multiple selections only for Size filter
    //     // var isSizeFilter = $(this).closest('.filter-size').length > 0;

    //      $(this).toggleClass('active');
    //     var currentTags = [];

    //     if (Shopify.queryParams.constraint) {
    //         currentTags = Shopify.queryParams.constraint.split('+');
    //     }

    //     // if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
    //     //     var otherTag = $(this).parents('.filter-tag').find("input:checked");
    //     //     if (otherTag.length > 0) {
    //     //         var tagName = otherTag.val();
    //     //         if (tagName) {
    //     //           var tagPos = currentTags.indexOf(tagName);
    //     //             if (tagPos >= 0) {
    //     //                 currentTags.splice(tagPos, 1);
    //     //             }
    //     //         }
    //     //     }
    //     // }

    //     var $checkbox = $(this).siblings('input');

    // // For non-size filters, clear existing selections in the same group
    // // if (!isSizeFilter) {

    //     $filter.find('input:checked').not($checkbox).each(function() {

    //         var oldTag = $(this).val();
    //         var tagPos = currentTags.indexOf(oldTag);

    //         if (tagPos >= 0) {
    //             currentTags.splice(tagPos, 1);
    //         }

    //         $(this).prop('checked', false);
    //         $(this).siblings('a').removeClass('active');
    //     });
    // // }

    // // Toggle current checkbox
    // $checkbox.prop('checked', !$checkbox.prop('checked'));


    //     var tagName = $(this).prev().val();
    //     if (tagName) {
    //         var tagPos = currentTags.indexOf(tagName);
    //         if (tagPos >= 0) {
    //             currentTags.splice(tagPos, 1);
    //         } else {
    //             currentTags.push(tagName);
    //         }
    //     }
    //     if (currentTags.length) {
    //         Shopify.queryParams.constraint = currentTags.join('+');
    //     } else {
    //         delete Shopify.queryParams.constraint;
    //     }
    //     collection.filterAjaxClick();
    //     e.preventDefault();
    //   });
    // },

    fillterTagEvents: function() {
      $("body").delegate('.filter-tag a:not(".clear"), .filter-tag label', 'click', function(e) {
        e.preventDefault();

        var $clicked   = $(this);
        var $filter    = $clicked.closest('.filter-tag');

        // --- Resolve the checkbox sibling ---
        // Handles both <a> (sibling input) and <label> (associated input via for="")
        var $checkbox = $clicked.is('label')
          ? $('#' + $clicked.attr('for'))
          : $clicked.siblings('input[type="checkbox"]');

        var filterKey   = $checkbox.attr('name');   // e.g. "filter.p.tag", "filter.v.option.Color"
        var filterValue = $checkbox.val();

        if (!filterKey || !filterValue) return;

        // --- Build current params from URL (preserves pagination, sort, etc.) ---
        var params = new URLSearchParams(window.location.search);

        // Get all currently active values for this specific filter key
        var activeValues = params.getAll(filterKey);
        var valueIndex   = activeValues.indexOf(filterValue);

        if (valueIndex >= 0) {
          // Already active → deactivate (OR logic: just remove this one value)
          activeValues.splice(valueIndex, 1);
          $checkbox.prop('checked', false);
          $clicked.removeClass('active');
        } else {
          // Not active → add it (OR: keep existing selections in same group)
          activeValues.push(filterValue);
          $checkbox.prop('checked', true);
          $clicked.addClass('active');
        }

        // --- Update params: delete all existing entries for this key, re-add updated list ---
        params.delete(filterKey);
        activeValues.forEach(function(val) {
          params.append(filterKey, val);
        });

        // Reset to page 1 when filter changes
        params.delete('page');

        // --- Write back to Shopify.queryParams so filterAjaxClick() picks it up ---
        Shopify.queryParams = {};
        params.forEach(function(val, key) {
          if (Shopify.queryParams[key] !== undefined) {
            // Multiple values for same key → convert to array
            if (!Array.isArray(Shopify.queryParams[key])) {
              Shopify.queryParams[key] = [Shopify.queryParams[key]];
            }
            Shopify.queryParams[key].push(val);
          } else {
            Shopify.queryParams[key] = val;
          }
        });

        collection.filterAjaxClick();
      });
    },

    filtertPriceRangEvents: function() {
    // Target ALL instances (desktop + mobile sidebars)
    document.querySelectorAll('.filter-price').forEach(function(section) {

      var minInput = section.querySelector('input[name="filter.v.price.gte"]');
      var maxInput = section.querySelector('input[name="filter.v.price.lte"]');
      var errMsg   = section.querySelector('.price-error');
      var applyBtn = section.querySelector('.price-apply');
      var clearBtn = section.querySelector('.price-clear');

      if (!minInput || !maxInput) return;

      function validate() {
        var min    = minInput.value.trim();
        var max    = maxInput.value.trim();
        var minVal = parseFloat(min);
        var maxVal = parseFloat(max);

        errMsg.textContent = '';
        minInput.closest('.price-input-wrap').classList.remove('error');
        maxInput.closest('.price-input-wrap').classList.remove('error');

        if (min === '' && max === '') {
          applyBtn.disabled = true; return false;
        }
        if (min !== '' && (isNaN(minVal) || minVal < 0)) {
          errMsg.textContent = 'Min price must be a positive number.';
          minInput.closest('.price-input-wrap').classList.add('error');
          applyBtn.disabled = true; return false;
        }
        if (max !== '' && (isNaN(maxVal) || maxVal < 0)) {
          errMsg.textContent = 'Max price must be a positive number.';
          maxInput.closest('.price-input-wrap').classList.add('error');
          applyBtn.disabled = true; return false;
        }
        if (min !== '' && max !== '' && minVal >= maxVal) {
          errMsg.textContent = 'Max must be greater than min.';
          minInput.closest('.price-input-wrap').classList.add('error');
          maxInput.closest('.price-input-wrap').classList.add('error');
          applyBtn.disabled = true; return false;
        }

        applyBtn.disabled = false; return true;
      }

      function clearActivePreset() {
        section.querySelectorAll('.price-preset').forEach(function(p) {
          p.classList.remove('active');
        });
      }

      // Sync the OTHER sidebar instance to match this one
      function syncOtherInstances() {
        document.querySelectorAll('.filter-price').forEach(function(otherSection) {
          if (otherSection === section) return;
          var otherMin = otherSection.querySelector('input[name="filter.v.price.gte"]');
          var otherMax = otherSection.querySelector('input[name="filter.v.price.lte"]');
          var otherClear = otherSection.querySelector('.price-clear');
          var otherApply = otherSection.querySelector('.price-apply');

          if (otherMin) otherMin.value = minInput.value;
          if (otherMax) otherMax.value = maxInput.value;

          // Sync preset active state
          otherSection.querySelectorAll('.price-preset').forEach(function(p) {
            p.classList.remove('active');
            if (p.dataset.min === minInput.value && p.dataset.max === maxInput.value) {
              p.classList.add('active');
            }
          });

          // Sync clear button visibility
          if (otherClear) {
            otherClear.style.display = (minInput.value || maxInput.value) ? 'block' : 'none';
          }
          if (otherApply) {
            otherApply.disabled = applyBtn.disabled;
          }
        });
      }

      // Preset buttons
      section.querySelectorAll('.price-preset').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var wasActive = btn.classList.contains('active');
          clearActivePreset();
          if (!wasActive) {
            btn.classList.add('active');
            minInput.value = btn.dataset.min;
            maxInput.value = btn.dataset.max;
          } else {
            minInput.value = '';
            maxInput.value = '';
          }
          validate();
          syncOtherInstances();
        });
      });

      minInput.addEventListener('input', function() {
        clearActivePreset();
        validate();
        syncOtherInstances();
      });

      maxInput.addEventListener('input', function() {
        clearActivePreset();
        validate();
        syncOtherInstances();
      });

      applyBtn.addEventListener('click', function() {
        if (!validate()) return;

        var params = new URLSearchParams(window.location.search);
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
        if (minInput.value) params.set('filter.v.price.gte', minInput.value);
        if (maxInput.value) params.set('filter.v.price.lte', maxInput.value);
        params.delete('page');

        Shopify.queryParams = {};
        params.forEach(function(val, key) {
          if (Shopify.queryParams[key] !== undefined) {
            if (!Array.isArray(Shopify.queryParams[key])) {
              Shopify.queryParams[key] = [Shopify.queryParams[key]];
            }
            Shopify.queryParams[key].push(val);
          } else {
            Shopify.queryParams[key] = val;
          }
        });

        clearBtn.style.display = 'block';
        syncOtherInstances();
        collection.filterAjaxClick();
      });

      clearBtn.addEventListener('click', function() {
        minInput.value = '';
        maxInput.value = '';
        clearActivePreset();
        errMsg.textContent = '';
        minInput.closest('.price-input-wrap').classList.remove('error');
        maxInput.closest('.price-input-wrap').classList.remove('error');
        applyBtn.disabled = true;
        clearBtn.style.display = 'none';

        var params = new URLSearchParams(window.location.search);
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
        params.delete('page');

        Shopify.queryParams = {};
        params.forEach(function(val, key) {
          Shopify.queryParams[key] = val;
        });

        syncOtherInstances();
        collection.filterAjaxClick();
      });

    }); // end forEach .filter-price
  },

//Old Code------------>
    // filterMapClearAll: function() {
    //   //clear all selection
    //     $("body").delegate( '.refined-widgets a.clear-all','click', function(e) {
    //         delete Shopify.queryParams.constraint;
    //         delete Shopify.queryParams.q;
    //         collection.filterAjaxClick();
    //         e.preventDefault();
    //       	$('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
          	
    //     });

    //      $("body").delegate( '.filter-block .clear', 'click', function(e) {
    //           var currentTags = [];
    //           var filterTag = $(this).parent().parent();
    //           if (Shopify.queryParams.constraint) {
    //               currentTags = Shopify.queryParams.constraint.split('+');
    //           }
    //           filterTag.find("input:checked").each(function() {
    //               var selectedTag = $(this);
    //               var tagName = selectedTag.val();
    //               if (tagName) {
    //                 var tagPos = currentTags.indexOf(tagName);
    //                   if (tagPos >= 0) {
    //                     //remove tag
    //                       currentTags.splice(tagPos, 1);
    //                   }
    //               }
    //           });
    //           filterTag.find("a").each(function() {
    //               $(this).removeClass("active");
    //           });
    //           if (currentTags.length) {
    //               Shopify.queryParams.constraint = currentTags.join('+');
    //           } else {
    //               delete Shopify.queryParams.constraint;
    //           }
    //           collection.filterAjaxClick();
    //           e.preventDefault();
    //       });

    // },

//     filterMapClear: function() {
//         $(".filter-tag").each(function() {
//           var filterTag = $(this);
//           if (filterTag.find("input:checked").length > 0) {
//               //has active tag
//               filterTag.find(".clear").show();
//           }
//         });
//     },
    //Old Code--------->
    // filterMapClear: function() {
    //   $(".filter-tag").each(function() {
    //     var filterTag = $(this);
    //     if (filterTag.find("input:checked").length > 0) {
    //       //has active tag
    //       filterTag.find(".clear").show().click(function(e) {    
    //         var currentTags = [];
    //         if (Shopify.queryParams.constraint) {
    //           currentTags = Shopify.queryParams.constraint.split('+');
    //         }
    //         filterTag.find("input:checked").each(function() {
    //           var selectedTag = $(this);
    //           var tagName = selectedTag.val();
    //           if (tagName) {
    //             var tagPos = currentTags.indexOf(tagName);
    //             if (tagPos >= 0) {
    //               //remove tag
    //               currentTags.splice(tagPos, 1);
    //             }
    //           }
    //         });
    //         if (currentTags.length) {
    //           Shopify.queryParams.constraint = currentTags.join('+');
    //         } else {
    //           delete Shopify.queryParams.constraint;
    //         }
    //         collection.filterAjaxClick();
    //         e.preventDefault();
    //       });
    //     }
    //   });
    // }, 
    
    filterMapClearAll: function() {
      // Clear all filters
      $("body").delegate('.refined-widgets a.clear-all', 'click', function(e) {
        e.preventDefault();
        // Remove all filter.* keys from queryParams
        $.each(Object.keys(Shopify.queryParams), function(i, key) {
          if (key.indexOf('filter.') === 0) {
            delete Shopify.queryParams[key];
          }
        });
        delete Shopify.queryParams.q;
        collection.filterAjaxClick();
        $('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
        $('.filter-tag input').prop('checked', false);
      });

      // Clear single filter group
      $("body").delegate('.filter-block .clear', 'click', function(e) {
        e.preventDefault();
        var filterTag = $(this).closest('.filter-tag');

        filterTag.find('input:checked').each(function() {
          var key  = $(this).attr('name');
          var val  = $(this).val();
          if (!key) return;

          var current = Shopify.queryParams[key];
          if (Array.isArray(current)) {
            var pos = current.indexOf(val);
            if (pos >= 0) current.splice(pos, 1);
            if (current.length === 0) delete Shopify.queryParams[key];
          } else {
            delete Shopify.queryParams[key];
          }
          $(this).prop('checked', false);
        });

        filterTag.find('a').removeClass('active');
        collection.filterAjaxClick();
      });
    },

    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          filterTag.find(".clear").show().off('click').on('click', function(e) {
            e.preventDefault();

            filterTag.find('input:checked').each(function() {
              var key = $(this).attr('name');
              var val = $(this).val();
              if (!key) return;

              var current = Shopify.queryParams[key];
              if (Array.isArray(current)) {
                var pos = current.indexOf(val);
                if (pos >= 0) current.splice(pos, 1);
                if (current.length === 0) delete Shopify.queryParams[key];
              } else {
                delete Shopify.queryParams[key];
              }
              $(this).prop('checked', false);
            });

            filterTag.find('a').removeClass('active');
            collection.filterAjaxClick();
          });
        }
      });
    },

//Old code-------------->
    // filterParams: function() {
    //     Shopify.queryParams = {};
    //     if (location.search.length) {
    //         for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    //             aKeyValue = aCouples[i].split('=');
    //             if (aKeyValue.length > 1) {
    //                 Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    //             }
    //         }
    //     }
    // },

    filterParams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        var pairs = location.search.substr(1).split('&');
        for (var i = 0; i < pairs.length; i++) {
          var aKeyValue = pairs[i].split('=');
          if (aKeyValue.length > 1) {
            var key = decodeURIComponent(aKeyValue[0]);
            var val = decodeURIComponent(aKeyValue[1]);

            if (Shopify.queryParams[key] !== undefined) {
              // Same key already exists → convert to array to hold multiple values
              if (!Array.isArray(Shopify.queryParams[key])) {
                Shopify.queryParams[key] = [Shopify.queryParams[key]];
              }
              Shopify.queryParams[key].push(val);
            } else {
              Shopify.queryParams[key] = val;
            }
          }
        }
      }
    },

    filterMapEvents: function() {
        collection.fillterTagEvents();
        collection.filtertPriceRangEvents(); 

    },

    resetFilter: function() {
        $(".filter-custom .active, .filter-links .active").removeClass("active");
        $(".filter-tag input:checked").attr("checked", false);

        //category
        var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
        if (cat && cat[1]) {
          $(".filter-links a[href='" + cat[0] + "']").addClass("active");
        }
    },

    filterMapData: function(data) {

        var currentList = $(".grid-uniform");


        var productList = $(data).find(".grid-uniform");

        currentList.replaceWith(productList);

        //replace paging
        if ($(".pagination").length > 0) {
          $(".pagination").replaceWith($(data).find(".pagination"));
        };

        $('.filter-blocks').replaceWith( $(data).find(".filter-blocks") );
        collection.filterMapClear();
      	quickView();
        var ajaxCartConfig = {
          cartContainer: '.enj-minicart-ajax',
          addToCartSelector: '.enj-add-to-cart-btn',
          cartCountSelector: '.enj-cartcount',
          cartCostSelector: '.enj-cartcost',
          moneyFormat: null
        };
          jQuery(function($) {
          ajaxCart.init(ajaxCartConfig);
        });
      
        function loadmore() {
          $('.loadmore').children('a').on('click',function(e){
            $('.loadmore').addClass('d-none');
            $('.loading.tshopify-popup').addClass('active');
            var link = $('.loadmore').children('a').attr('href');
            if (link != '#' ) {
              $('.load-data').load(link+' .product-grid-view .row')

              setTimeout(function(){
                $('.load-data .js_loadmore').each(function(){$(this).appendTo('.product-grid-view .row')})
                //           $('.loadmore').appendTo('.collection_prod .product-grid-view row')
                $('.loadmore').eq(0).remove();
                loadmore();
                quickView();
                var ajaxCartConfig = {
                  cartContainer: '.enj-minicart-ajax',
                  addToCartSelector: '.enj-add-to-cart-btn',
                  cartCountSelector: '.enj-cartcount',
                  cartCostSelector: '.enj-cartcost',
                  moneyFormat: null
                };
                  jQuery(function($) {
                  ajaxCart.init(ajaxCartConfig);
                });

                $('.loading.tshopify-popup').removeClass('active');
              },2000)
            } else {
              $('.loadmore').remove();
            }
            e.preventDefault();
          })
        }
        loadmore();
      
      
        jQuery('.engoj_select_color a').each(function(){
          jQuery(this).on("click",function(){
            var engoImage = jQuery(this).data('engojvariant-img');
            jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage }); 
            return false;
          });
        });

    },
//Old code----------->
    // filterCreateUrl: function(baseLink) {
    //   var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
    //   if (baseLink) {

    //     if (newQuery != "")
    //       return baseLink + "?" + newQuery;
    //     else
    //       return baseLink;
    //   }
    //   return location.pathname + "?" + newQuery;
    // },

    filterCreateUrl: function(baseLink) {
      // Build query string manually to support repeated keys (filter.v.option.color=red&filter.v.option.color=blue)
      // $.param() adds [] brackets for arrays which breaks Shopify S&D
      var parts = [];
      $.each(Shopify.queryParams, function(key, value) {
        if (Array.isArray(value)) {
          $.each(value, function(i, val) {
            parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
          });
        } else {
          parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
      });
      var newQuery = parts.join('&');

      if (baseLink) {
        return newQuery !== '' ? baseLink + '?' + newQuery : baseLink;
      }
      return location.pathname + (newQuery !== '' ? '?' + newQuery : '');
    },

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      collection.filterGetContent(newurl);
      console.log(newurl,'#Newurl');
    },

    filterGetContent: function(newurl) {

      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          showPopup('.loading');
        },

        success: function(data) {

          collection.filterMapData(data);
          console.log(data,'#Filterdata');
          collection.filterMapClear();
          hidePopup('.loading');
          hidePopup('.filter-to-left , .js-bg');
		  
        },

        error: function(xhr, text) {
          hidePopup('.loading');
          hidePopup('.filter-to-left, .js-bg');
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }

      });
    },



    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();

      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
      $(".collection-sorting a").click(function(e) {
        e.preventDefault();     
        if (!$(this).parent().hasClass("active")) {   
          Shopify.queryParams.sort_by = $(this).attr("href");
          collection.filterAjaxClick();    
          $(".collection-sorting li.active").removeClass("active");
          $(this).parent().addClass("active");
        }    
        var selected = $(this).text();   
        $(this).closest('.dropdown').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');  

      });
    },

    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {

    },


    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {

    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {

    },

  }

})(jQuery);